import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';
import { Heading } from '@bnnvara/typography';

export const Title = styled(Heading)`
  display: block;
  margin-bottom: 16px;
`;

export const Subtitle = styled.span`
  display: block;
  margin-bottom: 24px;
`;

export const ThemesContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoints.md} {
    flex-direction: row;
  }
`;

export const ThemesCategoryWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > span {
    font-size: 14px;
  }

  &:not(:first-child) {
    & > span {
      margin: 24px 0;
    }
  }

  ${breakpoints.md} {
    &:not(:last-child) {
      margin-right: 56px;
    }

    &:not(:first-child) {
      & > span {
        margin: 0 0 24px;
      }
    }
  }
`;

export const ThemesList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
`;

export const ThemesListItem = styled.li`
  & > div {
    margin: 0 0 8px;
  }
`;
